export const SET_USER = "SET_USER";
export const SET_USER_FAILURE = "SET_USER_FAILURE";
export const SET_USER_LOADER = "SET_USER_LOADER";
export const USER_LOGIN = "USER_LOGIN";
export const LOGIN_WITH_MICROSOFT = "LOGIN_WITH_MICROSOFT";
export const LOGIN_WITH_MICROSOFT_FALLBACK = "LOGIN_WITH_MICROSOFT_FALLBACK";
export const RESET = "RESET";